<template>
  <transition name="el-fade-in-linear">
    <div class="sn-bs-mask" v-if="visibility">
      <div
        class="sn-bs-land-dialog"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <div
          circle
          icon="el-icon-close"
          class="sn-bs-land-dialog__close-panel"
          size="mini"
          @click="handleClose"
        ></div>
        <div class="sn-bs-land-dialog__panel">
          <div class="sn-bs-land-dialog__panel-head">
            <p class="sn-bs-land-dialog__panel-title">农产品溯源</p>
          </div>
          <div class="sn-bs-land-dialog__panel-body" v-if="!loading">
            <el-scrollbar>
              <div class="sn-bs-content-item">
                <div class="sn-bs-content-item-left">
                  <img
                    class="sn-bs-content-item-left__img"
                    :src="setImgUrl(agriTraceInfo.goodsImgUrl, 50, 50)"
                    alt=""
                  />
                  <div class="sn-bs-content-item-info">
                    <p class="sn-bs-content-item-info__p">
                      {{ agriTraceInfo.goodsName }}
                    </p>
                    <span class="sn-bs-content-item-info__span">
                      采收时间：{{
                        agriTraceInfo.pickTime | formatDate("yyyy.MM.dd")
                      }}
                    </span>
                  </div>
                </div>
                <div class="sn-bs-content-item-right">
                  <span>{{ agriTraceInfo.pickOutput }}公斤</span>
                </div>
              </div>
              <div class="sn-bs-qr-code-box" :title="value" v-if="value">
                <qrcode-vue
                  :value="value"
                  :size="size"
                  foreground="#408852"
                  class="sn-bs-qr-code"
                ></qrcode-vue>
                <p>{{ agriTraceInfo.goodsName }}</p>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QrcodeVue from "qrcode.vue";

// import { area2Mu, setImgUrl, dateFormatMapping } from "@/utils";
import { mapState } from "vuex";
// import { qrCodeAgri } from "@/api/request/snkd.produce";

import { setImgUrl } from "@/utils";

export default {
  name: "BsAgriTraceDialog",
  components: { QrcodeVue },
  model: {
    prop: "visibility",
    event: "on-closed",
  },
  props: {
    visibility: {
      type: Boolean,
      default: false,
    },
    agriTraceInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      value: "",
      size: 145,
    };
  },
  methods: {
    setImgUrl,
    handleClose() {
      this.$emit("on-closed", false);
    },
  },
  computed: {
    ...mapState(["farmId", "companyId"]),
  },
  watch: {
    visibility(val) {
      console.log("val=========>", val);
      if (val) {
        this.$nextTick(() => {
          this.value =
            process.env.VUE_APP_TRACE_LINK + this.agriTraceInfo.pickNo;
          document.body.appendChild(this.$el);
          // document.body.appendChild(this.$el);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@include bs(land-dialog) {
  position: absolute;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -65%);
  width: 770px;
  height: 580px;
  background: url("~@/assets/images/bs/bg-dialog.png");

  @include e(close-panel) {
    position: absolute;
    right: 8px;
    top: -5px;
    width: 73px;
    height: 30px;
    line-height: 20px;
    padding: 0;
    z-index: 2;
    background: url("~@/assets/images/bs/bg-close.png");
    cursor: pointer;
  }
  @include e(panel) {
    position: relative;
    width: 100%;
    height: 100%;
    // box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
    // background-color: rgba(255, 255, 255, 0.9);
    // border-radius: $--border-radius-base;
  }
  @include e(panel-head) {
    height: 100px;
    box-sizing: border-box;
    padding-top: 8px;
    // background-color: #2cd2a9;
  }
  @include e(panel-title) {
    font-size: 24px;
    color: $--color-primary;
    box-sizing: border-box;
    padding: 0 14px;
    margin-left: 10px;
    line-height: 100px;
    font-weight: bold;
    color: #43e58e;
    text-align: center;
    // @include utils-ellipsis();
  }
  @include e(panel-body) {
    height: calc(100% - 100px);
    box-sizing: border-box;
  }
  @include bs(content-item) {
    width: 360px;
    margin: 0 auto;
    margin-top: 10px;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: rgba(27, 165, 101, 0.2);
    // cursor: pointer;

    @include bs(content-item-left) {
      display: flex;
      align-items: center;

      @include e(img) {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }

      @include bs(content-item-info) {
        margin-left: 12px;
        @include e(p) {
          margin-bottom: 12px;
          font-size: 14px;
          font-weight: bold;
          color: $--color-white;
          line-height: 14px;
        }

        @include e(span) {
          font-size: 14px;
          font-weight: 400;
          color: #9dd1d7;
          line-height: 14px;
        }
      }
    }

    @include bs(content-item-right) {
      text-align: center;
      font-size: 16px;
      color: $--color-primary;
      font-weight: bold;
    }
  }

  @include bs(qr-code-box) {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 360px;
    height: 360px;
    margin: 0 auto;
    background-color: $--color-white;
    background-image: url("~@/assets/images/bs/bg-qr-code-decorate.png");
    background-size: 330px 330px;
    background-position: center;
    background-repeat: no-repeat;

    p {
      margin-top: 10px;
      color: #408852;
      font-size: 14px;
      font-weight: bold;
    }
  }

  @include bs(qr-code) {
    margin-top: 140px;
  }
}

@include bs(mask) {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba($color: #000000, $alpha: 0.5);
}

::v-deep {
  .el-scrollbar__thumb {
    background-color: $--scrollbar-background-color;
  }
}
</style>
